<template>
  <div class="animated fadeIn profile-component main-div">
    <vLoading v-if="vLoading" />
    <div v-if="!notAllowed">
      <div v-if="loaded">
        <v-row class="pt-1">
          <v-col sm="6" cols="12">
            <div class="pt-1 fs-small">
              <router-link to="/map" class="no-underline">
                <span class="c-primary"> انتخاب استان </span>
              </router-link>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('state')" class="pointer">
                استان {{ companyInfo.state }}
              </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('company')" class="pointer"> شرکت‌ها </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span class="font-weight-bold">
                {{ companyInfo.name }}
              </span>
            </div>
          </v-col>
          <v-col sm="6" cols="12" class="text-left">
            <v-btn
              @click="goToMap('state')"
              class="bc-primary text-white no-underline"
              ><span class="c-light">بازگشت به نقشه</span></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="common-card mt-1 mb-1">
              <p class="c-dark red--text text--lighten-1 mb-0">
                <v-icon class="red--text me-1">mdi-alert</v-icon>دانش‌پژوه
                گرامی، اطلاعات مربوط به شرکت دانش‌بنیان "{{ companyInfo.name }}"
                حاصل خوداظهاری خود شرکت است. لطفا در صورتی که مغایرتی در اطلاعات
                مشاهده کردید با شرکت مربوطه تماس حاصل بفرمایید.
              </p>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-card">
              <v-row class="uni-header">
                <v-col cols="12" class="d-flex flex-column flex-sm-row">
                  <div class="view-imageBox">
                    <img
                      :src="
                        companyInfo.avatar
                          ? companyInfo.avatar
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                      "
                    />
                  </div>
                  <div class="description-box px-5">
                    <h5 class="mt-1 c-dark fs-xxlarge">
                      {{ companyInfo.name }}
                    </h5>
                    <p v-if="companyInfo.description" class="c-grey fs-medium">
                      {{
                        companyInfo.description.length > 180
                          ? companyInfo.description.slice(0, 180) + "..."
                          : companyInfo.description
                      }}
                    </p>
                    <p v-else class="c-grey fs-small">
                      توضیحی برای شرکت ثبت نشده است.
                    </p>
                  </div>
                </v-col>
              </v-row>
              <div
                v-if="companyInfo.description.length > 220"
                class="text-left"
              >
                <v-btn
                  class="seeMore-btn"
                  @click="openSeeMoreModal('description')"
                  text
                >
                  <span class="c-primary">مشاهده بیشتر</span>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس شرکت</h5>
              <div class="pt-2 c-grey">
                <v-icon class="ps-2">$Location</v-icon>

                <span class="fs-medium">
                  نشانی شرکت:
                  {{
                    companyInfo.state +
                    ", " +
                    companyInfo.city +
                    (companyInfo.city ? ", " : "")
                  }}
                  {{ companyInfo.address ? companyInfo.address : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="ps-2">$Phone</v-icon>
                <span v-if="!companyInfo.tel" class="fs-medium">
                  تلفن‌های تماس: --</span
                >
                <span class="fs-medium" v-else>
                  تلفن‌های تماس:
                  {{ companyInfo.tel }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2 ps-2">$Email</v-icon>
                <span v-if="!companyInfo.email" class="fs-medium"
                  >ایمیل : --</span
                >
                <span class="fs-medium" v-else>
                  ایمیل :
                  {{ companyInfo.email }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="ps-2">$Url</v-icon>
                <span class="fs-medium" v-if="companyInfo.website">
                  آدرس‌‌ تارنما:
                  <a :href="checkWebsite()" target="_blank">{{
                    companyInfo.website
                  }}</a>
                </span>
                <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-stretch card-height">
              <v-row>
                <v-col class="center-col">
                  <h5 class="mb-4 fs-xxlarge">محصولات</h5>
                  <v-spacer></v-spacer>
                  <h6 class="mt-1 fs-large">
                    {{
                      companyInfo.products.length
                        ? companyInfo.products.length + " محصول"
                        : ""
                    }}
                  </h6>
                </v-col>
              </v-row>

              <div v-if="!companyInfo.products.length" class="text-center mt-8">
                <hr />
                <span> محصولی برای این شرکت به ثبت نرسیده است.</span>
                <hr />
              </div>
              <div v-else>
                <div v-if="companyInfo.products.length > 3">
                  <div
                    v-for="(mission, index) in companyInfo.products.slice(0, 3)"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{
                        mission.title.length > 70
                          ? mission.title.slice(0, 70) + "..."
                          : mission.title
                      }}
                    </li>
                  </div>
                  <div class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('mission')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-for="(mission, index) in companyInfo.products"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{
                        mission.title.length > 70
                          ? mission.title.slice(0, 70) + "..."
                          : mission.title
                      }}
                    </li>
                  </div>
                  <div v-if="showMissionMoreBtn" class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('mission')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-stretch card-height">
              <v-row>
                <v-col class="">
                  <h5 class="mb-4 fs-xxlarge">موضوع شرکت</h5>
                </v-col>
              </v-row>

              <div v-if="!companyInfo.catName" class="text-center mt-8">
                <hr />
                <span>موضوعی برای این شرکت به ثبت نرسیده است.</span>
                <hr />
              </div>
              <div v-else>
                <li class="fs-medium c-grey">
                  <v-icon>mdi-circle-medium</v-icon>{{ companyInfo.catName }}
                </li>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="type != 'mobile'">
          <v-col>
            <v-card class="common-card w-100">
              <v-card-title>
                <h5 class="fs-xxlarge">گالری تصاویر</h5>
              </v-card-title>
              <div
                v-if="!companyInfo.gallery.length"
                class="px-5 text-center mb-16"
              >
                <hr />
                <span class="fs-small c-grey mx-auto">
                  تصویری برای این شرکت به ثبت نرسیده است.
                </span>
                <hr />
              </div>
              <v-row class="d-flex flex-column mt-2" v-else>
                <v-row>
                  <v-col
                    class="text-center img-col d-flex py-0"
                    sm="4"
                    md="4"
                    lg="2"
                    xl="2"
                    v-for="(img, index) in companyInfo.gallery"
                    :key="index"
                  >
                    <img :src="img.url" class="gallery-img mb-2" />
                    <span class="fs-medium">{{
                      img.title.length > 20
                        ? img.title.slice(0, 20) + "..."
                        : img.title
                    }}</span>
                  </v-col>
                </v-row>
                <v-row class="justify-content-center mb-3">
                  <v-btn
                    :to="'/companyImages/' + companyId"
                    class="see-btn text-primary font-weight-bold"
                  >
                    <span> مشاهده همه تصاویر </span>
                    <v-icon large> mdi-chevron-left </v-icon>
                  </v-btn>
                </v-row></v-row
              >
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-card class="common-card w-100">
              <v-card-title>
                <h5>گالری تصاویر</h5>
              </v-card-title>
              <div
                v-if="!companyInfo.gallery.length"
                class="pa-5 text-center mb-16"
              >
                <hr />
                <span class="text-center mx-auto"
                  >تصویری برای این شرکت به ثبت نرسیده است.</span
                >
                <hr />
              </div>
              <div v-else>
                <v-row class="main-div">
                  <v-carousel
                    v-model="model"
                    hide-delimiters
                    :show-arrows="companyInfo.gallery.length > 1"
                  >
                    <v-carousel-item
                      cycle
                      v-for="(img, index) in companyInfo.gallery"
                      :key="index"
                      :src="img.url"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                      class="slider"
                    >
                    </v-carousel-item>
                  </v-carousel>
                </v-row>
                <v-row class="justify-content-center mt-4">
                  <v-btn
                    :to="'/companyImages/' + companyId"
                    class="see-btn text-primary font-weight-bold"
                  >
                    <span class="fs-large"> مشاهده همه تصاویر </span>
                    <v-icon large> mdi-chevron-left </v-icon>
                  </v-btn>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog v-model="seeMoreModal" width="600">
          <v-card v-if="seeMoreType == 'description'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">{{ companyInfo.name }}</h5>
                </v-col>
                <v-col class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <p class="c-grey fs-medium" style="line-height: 30px">
                {{ companyInfo.description }}
              </p>
            </v-container>
          </v-card>
          <v-card v-if="seeMoreType == 'mission'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">محصولات</h5>
                </v-col>
                <v-col class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <div class="products-box">
                <div
                  v-for="(mission, index) in companyInfo.products"
                  :key="index"
                  class="mb-5"
                >
                  <span class="c-grey fs-medium">
                    <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                    {{ " " + mission.title }}
                  </span>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div v-else>
      <v-row class="p-1">
        <v-col sm="6" cols="12"> &nbsp; </v-col>
        <v-col sm="6" cols="12" class="text-left">
          <v-btn to="/map" class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-card class="mt-3">
        <v-container>
          <hr />
          <h5 class="text-center">دسترسی به اطلاعات این شرکت وجود ندارد</h5>
          <hr />
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Chart,
  },
  data() {
    return {
      model: 0,
      companyId: "",
      busy: true,
      value: 0,
      companyInfo: {
        logoSrc: "",
        description: "",
        contactInfo: {
          address: "",
          phoneNumber: "",
          email: "",
          url: "",
        },
        products: [],
        galleryImages: [],
      },
      list: [],
      loaded: false,
      notAllowed: false,
      type: "",
      isBusy: false,
      vLoading: false,
      seeMoreModal: false,
      seeMoreType: "",
    };
  },
  methods: {
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.companyInfo.state);
        localStorage.setItem("stateId", this.companyInfo.stateId);
      } else if (to == "company") {
        localStorage.setItem("state", this.companyInfo.state);
        localStorage.setItem("stateId", this.companyInfo.stateId);
        localStorage.setItem("item", "company");
      }
    },
    getProfileInfo() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }
      this.isBusy = true;
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/company/getInfo",
          {
            companyId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companyInfo = res.data;
          this.vLoading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403) {
            this.notAllowed = true;
          } else {
            console.log(err);
            this.toast(err.response.data, "error");
          }
        });
    },
    checkWebsite() {
      if (
        this.companyInfo.website.indexOf("http://") == 0 ||
        this.companyInfo.website.indexOf("https://") == 0
      ) {
        return this.companyInfo.website;
      } else {
        return "//" + this.companyInfo.website;
      }
    },
  },
  computed: {
    showMissionMoreBtn() {
      let temp;
      temp = this.companyInfo.products.filter((x) => x.title.length > 70);
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.companyId = this.$route.params.id;
    this.getProfileInfo();
  },
};
</script>
<style lang="scss">
.modal-card {
  .mehvars-box,
  .products-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
}
</style>
